export const FULL_SCREEN_Z_INDEX = 1201;
export const CALENDAR_FULL_SCREEN_ZINDEX = FULL_SCREEN_Z_INDEX + 1;
export const CALENDAR_FULL_SCREEN_MODAL_ZINDEX = FULL_SCREEN_Z_INDEX + 2;
